import { render, staticRenderFns } from "./06-privacy.vue?vue&type=template&id=96c9e4f8&scoped=true&"
import script from "./06-privacy.vue?vue&type=script&lang=js&"
export * from "./06-privacy.vue?vue&type=script&lang=js&"
import style0 from "./06-privacy.vue?vue&type=style&index=0&id=96c9e4f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96c9e4f8",
  null
  
)

export default component.exports